import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}
const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {
	return (
		<div className='brand' style={{ justifyContent: "center" }}>
			<div className='brand-logo'>
				<h1 className='brand-title '>
					<a
						href="https://get-widget.ru"
						aria-label="Logo"
						target="_blank"
						rel="noopener noreferrer">
						<Logo />
					</a>
				</h1>
			</div>
		</div >
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
